import { JustifyContent } from "../justify-content";

enum DialogSizes {
    Small = 'small',
    Medium = 'medium' ,
    Large = 'large',
    XLarge = 'xlarge'
}

export const DialogSizesValues = {
    [DialogSizes.Small]: 'sm',
    [DialogSizes.Medium]: 'md',
    [DialogSizes.Large]: 'lg',
    [DialogSizes.XLarge]: 'xl'
};

interface AtlDialogProps { 
    show: boolean;
    dialogTitle?: string;
    displayCloseButton?: boolean;
    size?: DialogSizes;
    static?: boolean;
    backdrop?: boolean;
    keyboard?: boolean;
    footerJustifyContent?: JustifyContent;
}

enum DialogEvents {
    DialogClosing = 'dialog-close',
    DialogClosed = 'dialog-closed',
    DialogBlocked = 'dialog-close-blocked',
    DialogOpen = 'dialog-panel-open',
    DialogOpened = 'dialog-panel-opened'
}

export { DialogSizes, DialogEvents, JustifyContent };
export type { AtlDialogProps };

export const DialogTags = {
    Dialog: 'atlantis-dialog'
} as const;